import { Configuration, ObjectElementFactory } from "duice";
import { ElementRegistry } from "duice";
import { MarkedElement } from "./MarkedElement";
/**
 * Marked Element Factory
 */
export class MarkedElementFactory extends ObjectElementFactory {
    /**
     * Creates element
     * @param htmlElement html element
     * @param bindData bind data
     * @param context context
     */
    createElement(htmlElement, bindData, context) {
        return new MarkedElement(htmlElement, bindData, context);
    }
}
/**
 * Static block
 */
(() => {
    // register
    ElementRegistry.register(`${Configuration.getNamespace()}-marked`, new MarkedElementFactory());
})();
//# sourceMappingURL=MarkedElementFactory.js.map